import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { ProjectDetailsFeaturesComponent } from '@app/components/project-details/project-details-features/project-details-features.component';
import { ProjectDetailsDownloadsComponent } from '@app/components/project-details/project-details-downloads/project-details-downloads.component';
import { ProjectDetailsGalleryComponent } from '@app/components/project-details/project-details-gallery/project-details-gallery.component';
import { ProjectDetailsHeaderComponent } from '@app/components/project-details/project-details-header/project-details-header.component';
import { ProjectDetailsVideosComponent } from '@app/components/project-details/project-details-videos/project-details-videos.component';
import { ProjectDetailsSectionAComponent } from '@app/components/project-details/project-details-section-a/project-details-section-a.component';
import { ProjectDetailsSectionBComponent } from '@app/components/project-details/project-details-section-b/project-details-section-b.component';
import { ProjectDetailsSectionCComponent } from '@app/components/project-details/project-details-section-c/project-details-section-c.component';
import { ProjectDetailsSectionDComponent } from '@app/components/project-details/project-details-section-d/project-details-section-d.component';
import { ProjectDetailsSectionEComponent } from '@app/components/project-details/project-details-section-e/project-details-section-e.component';
import { ProjectDetailsSectionFComponent } from '@app/components/project-details/project-details-section-f/project-details-section-f.component';
import { ProjectDetailsSectionGComponent } from '@app/components/project-details/project-details-section-g/project-details-section-g.component';
import { ProjectDetailsSectionHComponent } from '@app/components/project-details/project-details-section-h/project-details-section-h.component';
import { ProjectDetailsSectionIComponent } from '@app/components/project-details/project-details-section-i/project-details-section-i.component';
import { ProjectPublicResponse } from '@app/models/project.models';
import { GenericStore } from '@app/stores/generic.store';
import { GenericProjectStore } from '@app/stores/projects/generic-project.store';
import { ProjectsStore } from '@app/stores/projects/projects.store';

@Component({
  selector: 'app-project-details',
  imports: [
    ProjectDetailsHeaderComponent,
    ProjectDetailsFeaturesComponent,
    ProjectDetailsGalleryComponent,
    ProjectDetailsVideosComponent,
    ProjectDetailsDownloadsComponent,
    ProjectDetailsSectionAComponent,
    ProjectDetailsSectionBComponent,
    ProjectDetailsSectionCComponent,
    ProjectDetailsSectionDComponent,
    ProjectDetailsSectionEComponent,
    ProjectDetailsSectionFComponent,
    ProjectDetailsSectionGComponent,
    ProjectDetailsSectionHComponent,
    ProjectDetailsSectionIComponent,
  ],
  templateUrl: './project-details.component.html',
  styleUrl: './project-details.component.scss',
})
export class ProjectDetailsComponent {
  projectStore = inject(ProjectsStore);
  genericStore = inject(GenericStore);
  genericProjectStore = inject(GenericProjectStore);
  protected projectDetails?: ProjectPublicResponse;
  protected translationKey = 'projectDetails.';
  constructor(
    private route: ActivatedRoute,
    private destroyRef: DestroyRef,
  ) {
    this.projectStore
      .getProjectById(route.snapshot.params['id'])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: ProjectPublicResponse) => {
        this.projectDetails = response;
      });
  }
}
